(ns heraldicon.frontend.blazonry-editor.shared)

(def blazonry-editor-path
  [:ui :blazonry-editor])
